import React, {useState} from 'react'
import styles from '../checkout/etprofile.module.scss'
import { useRouter } from 'next/router'
import endpoints from '../../../utility/endpoints';
import axios from 'axios';
import { BlobServiceClient } from "@azure/storage-blob";
import { IoIosArrowRoundForward, IoIosArrowRoundBack } from "react-icons/io"
function ETProfile({ onNext, onPrevious,leadPlatform,cluster }) {
  console.log(leadPlatform);
    const route = useRouter();
    const [etName, setETName] = useState('');
    const [logoFile, setLogoFile] = useState("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/etdefault.jpg");
    const [functionValue, setFunctionValue] = useState('');
    const [regionValue, setRegionValue] = useState('');
    const [description, setDescription] = useState('');
    const [fileTypesp, setfileTypesp] = useState([
        "jpg",
        "jpeg",
        "png",
       ]);
    const [fileerror, setFileError] = useState(false);	
    const [filesuccess, setFilesuccess] = useState(false);	
    const [file, setFile] = useState(null);
    const [fileNameOriginal, setFileName] = useState(null);
    const [showFileName, setShowFileName] = useState(false);
    const [submitForm, setSubmitForm] = React.useState(false);	
    const [functionname,setFunctionname]=useState(leadPlatform.field_options)
    const [clustername,setClustername]=useState(cluster.field_options)
 const handleFileChange = (event) => {	
    const file = event.target.files[0];	
    if (file) {	
      uploadFile(file);
      setLogoFile(file);	
    }	
  };

      let azurefilepath;
      const blobSasUrl =
      "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
      
      const blobSasUrlNew = endpoints.blobSasUrlNew;
      // "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
      const blobServiceClient = new BlobServiceClient(blobSasUrlNew);
      
      const containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");
      
      const uploadFile = async  (imageFile) => {
        {/*console.log(file.name, "pdfsauto");
        azurefilepath= "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp"+file.name;
        console.log("azure file path",azurefilepath)
        setFile(file);
        setShowFileName(true);
        setFileName(file.name);*/}
      const originalFileName = imageFile.name;	
          let fileName = originalFileName;	
          let index = 1;	
          // Check if the file name already exists in the container	
          while (await containerClient.getBlockBlobClient(fileName).exists()) {	
            const extension = originalFileName.substring(originalFileName.lastIndexOf('.'));	
            fileName = `${originalFileName.substring(0, originalFileName.lastIndexOf('.'))}_${index}${extension}`;	
            index++;	
          }	
          const blockBlobClient = containerClient.getBlockBlobClient(fileName);	
          try {	
            await blockBlobClient.uploadBrowserData(imageFile);	
            console.log('Image uploaded successfully!');	
            setLogoFile("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+fileName)	
            setFilesuccess(true);	
          } catch (error) {	
           setFileError(true);	
            console.error('Error uploading image:', error);	
          }
      };
      
      const uploadButtonClick = async () => {
        //console.log(fileNameOriginal, "fileName", file);
      
        let fileNameWithSpaces = fileNameOriginal;
        let fileName = fileNameWithSpaces.replace(/ /g, "");
        let ar = fileNameOriginal.split(".");
        let extension = ar[ar.length - 1];
        const fileSize = file.size;
      
        try {
          const blockBlobClient = containerClient.getBlockBlobClient(fileName);
          const options = { blobHTTPHeaders: { blobContentType: file.type } };
          const resp = await blockBlobClient.uploadBrowserData(file, options);
          console.log(resp, "response of azure");
          let url = resp._response.request.url;
          setSuccessModal(true);
        } catch (error) {
          console.log(error, "erro");
          alert("Could not upload");
        }
      };
      const onFormsubmit = async () => {

        let authCheck = JSON.parse(localStorage.getItem("auth")).data;

        if (!etName) {	
          setSubmitForm(true);	
        }	
        else{
              let auth = await JSON.parse(localStorage.getItem("auth")).data;
              let orderID = await JSON.parse(localStorage.getItem("orderID"));
              axios({
                method: "POST",
                url: `${endpoints.baseUrl}/twin/createCartFormDataEntry`,
                headers: {
                  Authorization: `${auth.accessToken}|${auth.email}`,
                },
                data: {
                  ET_name:etName,
                  ET_logo:logoFile,
                  "employeeTwinID" : "",
                  "functionField" : functionValue,
                  "region" : regionValue,
                  "descriptions" : description,
                  "Business_owner" : "",
                  "Country_code" : "",
                  "GL_Account" : "",
                  "Cost_centre_owner" : "",
                  "To_country_code" : "",
                  "To_cost_centre" : "",
                  "commentText": "",
                  "commentType" : "",
                   "orderID":orderID
                },
              }).then((resp) => {
                if (resp.data.code == 403) {
                  setLoading(false)
                 
                } 
                else if (resp.data.code == 201 || resp.data.code == 200) {
                
                    
                //    // route.push('/CCDetails');
                if (typeof onNext === 'function') {
                    onNext(); // Call onNext if it's a function
                }

                      
                  
                } 
                else if (resp.data.code == 400) {
                
                }
              });
            
          }
      
      };

    return (
        <div className={styles.et_container}>
            <div className={styles.et_main_content}>
                <p className={styles.et_top_heading}>Create your ET Profile</p>
                <div className={styles.etname_content}>
                    <div className={styles.et_content}>
                        <label className={styles.et_label}>Name Your ET<span className={styles.et_span}>* </span> </label>
                        <input type='text' className={styles.et_input} 
                        value={etName}
                        onChange={(e) => setETName(e.target.value)}
                        name="etname"
                        />
                    </div>
                    <div className={styles.et_content}>
                        <label className={styles.et_label}>Upload Logo
                            {/* <span className={styles.et_span_logo}>*200px X 200px Image Size</span> */}
                        </label>
                        <div className={styles.et_logo_container}>
                            <input type='file' className={`${styles.et_input} ${styles.logo_input}`}
                            onChange={(e)=>{handleFileChange(e)}}
                            name="etlogo"/>
                            <img src='./assets/img/Rectangle-347.png' alt='' className={styles.Uploadlogo} />
                        </div>
                    </div>
                </div>
                <div className={styles.etupload_content}>
                    <div className={styles.et_content}>
                        <label className={styles.et_label}>Lead Platform</label>
                        {/* <input type='text' className='et_input' /> */}
                        <select className={styles.et_input}
                        value={functionValue}
                        onChange={(e) => setFunctionValue(e.target.value)}
                        name="etfunction">
                            <option>Select</option>
                          {functionname.map((item, index) => {
                          return (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          );
                        })};
                           
                        </select>
                    </div>
                    <div className={styles.et_content}>
                        <label className={styles.et_label}>Cluster</label>
                        <select className={styles.et_input}
                        value={regionValue}
                        onChange={(e) => setRegionValue(e.target.value)}
                        name="etregion">
                            <option>Select</option>
                            {clustername.map((item, index) => {
                          return (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          );
                        })};
                        </select>
                    </div>
                </div>
                <div className={styles.et_descrip_content}>
                    <label className={styles.et_des_label}>Descriptions</label>
                    <textarea rows="4" cols="50" className={styles.et_des_input}
                     value={description}
                     onChange={(e) => setDescription(e.target.value)}
                     name="description"></textarea>
                </div>
                {/* <div className={styles.et_proceed_btn_content}>
                    <button className={styles.et_proceed_btn} onClick={onFormsubmit}>
                        Proceed to hire <IoIosArrowRoundForward className={styles.et_arrow_btn} />
                    </button>
                </div> */}
                <div className={styles.et_proceed_btn_content}>
                    <button className={styles.et_proceed_btn} onClick={onPrevious}>
                        <IoIosArrowRoundBack className={styles.et_arrow_btn} />Previous
                    </button>
                    <button className={styles.et_proceed_btn} onClick={onFormsubmit}>
                        Proceed to hire <IoIosArrowRoundForward className={styles.et_arrow_btn} />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ETProfile
